import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import {
  locateOnTheMap,
  selectLocationIcon,
  useCurrentLocationLabel,
} from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import Image from 'next/image';
import React from 'react';
import { handleGetLocation } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers'; // adjust path
import Button from '@porterin/component-library/src/base-components/button/Button';
import { getScreenName } from '@porterin/lead-flow/src/components/FareEstimateHelper';

interface AutoDetectLocationCmpProps {
  isLoading?: boolean;
  setIsLoading?: (loading: boolean) => void;
  setError?: (value: React.SetStateAction<string | null>) => void;
  error?: string | null;
}

export const AutoDetectLocationCmpDesktop: React.FC<
  AutoDetectLocationCmpProps
> = ({ isLoading = false, setIsLoading, setError, error }) => {
  const { state, selectLocation } = useLocation();

  const label =
    state?.waypoint === 'Drop' ? locateOnTheMap : useCurrentLocationLabel;

  return (
    <Button
      className="flex items-center justify-center bg-white p-[1.6rem] border-b-[1px] border-[#4E525B1F] disabled:opacity-50 font-normal"
      data-testid="detect-location-btn"
      identifiers={{ id: 'detect-location-btn' }}
      interactions={{
        onClick: () => {
          handleGetLocation({
            setIsLoading,
            setError,
            selectLocation,
            waypoint: state?.waypoint,
            screen_name: getScreenName(),
          });
          if (error) console.log(error);
        },
      }}
      buttonOptions={{ disabled: isLoading }}
    >
      <Image
        src={selectLocationIcon}
        alt="Select Location"
        width={20}
        height={20}
        className="mr-3"
      />
      <span className="text-[1.4rem]">{label}</span>
    </Button>
  );
};
